import React, { Suspense } from "react";
import { Route, Routes, Navigate } from "react-router";
import AuthRouteWrapper from "./AuthRouteWrapper";
import ProtectedRouteWrapper from "./ProtectedRouteWrapper";
import routes from "./routeConfig.js";
import MainLayout from "../layout/MainLayout";
import { Spin } from "antd";
import Loader from "../Components/Loader";
import AdminLayout from "../modules/AdminDashboard/AdminLayout.js";

const NavigationManager = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        {routes
          .filter((route) => route.layout === "MainLayout")
          .map(({ path, component, wrapRoute }) => {
            const WrappedComponent = () => (
              <Suspense
                fallback={
                  <Spin
                    size="large"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                }
              >
                {React.createElement(component)}
              </Suspense>
            );

            switch (wrapRoute) {
              case "AuthRoute":
                return (
                  <Route key={path} element={<AuthRouteWrapper />}>
                    <Route path={path} Component={WrappedComponent} />
                  </Route>
                );
              case "ProtectedRoute":
                return (
                  <Route key={path} element={<ProtectedRouteWrapper />}>
                    <Route path={path} Component={WrappedComponent} />
                  </Route>
                );
              default:
                return (
                  <Route key={path} path={path} Component={WrappedComponent} />
                );
            }
          })}
      </Route>

      <Route element={<AdminLayout />}>
        {routes
          .filter((route) => route.layout === "AdminLayout")
          .map(({ path, component, wrapRoute }) => {
            const WrappedComponent = () => (
              <Suspense
                fallback={
                  <Spin
                    size="large"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                }
              >
                {React.createElement(component)}
              </Suspense>
            );

            switch (wrapRoute) {
              case "AuthRoute":
                return (
                  <Route key={path} element={<AuthRouteWrapper />}>
                    <Route path={path} Component={WrappedComponent} />
                  </Route>
                );
              case "ProtectedRoute":
                return (
                  <Route key={path} element={<ProtectedRouteWrapper />}>
                    <Route path={path} Component={WrappedComponent} />
                  </Route>
                );
              default:
                return (
                  <Route key={path} path={path} Component={WrappedComponent} />
                );
            }
          })}
      </Route>

      {routes
        .filter(
          (route) =>
            route.layout !== "AdminLayout" || route.layout !== "MainLayout"
        )
        .map(({ path, component, wrapRoute }) => {
          const WrappedComponent = () => (
            <Suspense fallback={<Loader />}>
              {React.createElement(component)}
            </Suspense>
          );

          switch (wrapRoute) {
            case "AuthRoute":
              return (
                <Route key={path} element={<AuthRouteWrapper />}>
                  <Route path={path} Component={WrappedComponent} />
                </Route>
              );
            case "ProtectedRoute":
              return (
                <Route key={path} element={<ProtectedRouteWrapper />}>
                  <Route path={path} Component={WrappedComponent} />
                </Route>
              );
            default:
              return (
                <Route key={path} path={path} Component={WrappedComponent} />
              );
          }
        })}
      {/* Catch-all route: redirect any unmatched routes to login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default NavigationManager;
